<template>
  <div>
    <fzg-fa-pc v-if="isPc()"></fzg-fa-pc>
    <fzg-fa-mobile v-else></fzg-fa-mobile>
  </div>
</template>


<script>
import FzgFaPc from './FzgFaPc.vue'
import FzgFaMobile from './FzgFaMobile.vue'
import util from '@/assets/js/util'
export default {
  components: {
    FzgFaPc,
    FzgFaMobile,
  },
  methods: {
    isPc() {
      return util.isPc()
    },
  },

}
</script>


<style lang="scss">

</style>



// WEBPACK FOOTER //
// FzgFa.vue?1882cc66